export const profileMessages = {
  firstName: "First Name:",
  lastName: "Last Name:",
  loggedInAs: "Username:",
  email: "E-mail:",
  myOrganization: "My organization:",
  myGatedCommunities: "My Knowledge Base:",
  myLanguageSelection: {
    myLanguageSelection: "My language selection:",
    update: "Update",
    continue: "Continue",
    setYourLanguages: "Set up your languages",
    updateYourLanguage: "Update your languages",
    updateLanguageDescription: "Select the languages you use in the app so we can tailor your experience.",
    nativeLanguages: "My native language(s)",
    nativeLanguagesTooltip: "Select all the language(s) you speak fluently or grew up with.",
    mainLanguages: "My main languages",
    mainLanguagesTooltip:
      "Pick the language(s) you'll use most often for translation, content creation, and AI chat. You can update this later if your needs change.",
    additionalLanguages: "Additional languages",
    additionalLanguagesTooltip:
      "Add any extra languages you might use occasionally or want quick access to. You can update this later if your needs change.",
    successTitle: "Great work. You're all set!",
    successDescription: "Your language preferences are saved. You can update them anytime in",
    successDescriptionLink: "My Profile",
    successDescriptionEnd: ". Here's what you selected:",
    startExploring: "Start Exploring"
  },
  appVersion: "Application version:",
  password: {
    title: "New password",
    current: "Current password",
    change: "Update",
    changeSuccess: "Password has been changed successfully",
    changeError: "Error occurred during password change. Your password has not been changed",
    new: "New password",
    newRepeat: "Confirm new password",
    noMatch: "Passwords does not match",
    wrong: "Wrong password"
  },
  legalDocument: {
    GENERAL_TERMS: "General Terms & Conditions",
    PRIVACY_POLICY_REQUESTERS: "Privacy Policy"
  },
  updateNames: "Update",
  deleteAccount: {
    button: "Delete Account",
    confirmTitle: "Delete Account",
    confirmMessage1: "Are you sure you want to delete your account?",
    confirmMessage2: "By continuing, you will get redirected to complete the account deletion process.",
    cancel: "Cancel",
    confirm: "Delete my account"
  }
}
